import { render, staticRenderFns } from "./InquiryFiles.vue?vue&type=template&id=264ca420&"
import script from "./InquiryFiles.vue?vue&type=script&lang=js&"
export * from "./InquiryFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports